import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { withMsal } from '@azure/msal-react';
import ReferralNavbar from './components/ReferralNavbar';
import ReferralForm from './components/Form/ReferralForm';
import { loginRequest } from './components/auth/AzureADProvider';
import DownloadCSV from './components/DownloadCSV';

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            instance: this.props.msalContext.instance
        }
        if (this.props.msalContext.accounts.length <= 0)
            this.state.instance.loginRedirect(loginRequest).catch(e => {
                console.log(e);
            });
    }

    render() {
        let isAuth = this.props.msalContext.accounts.length > 0;
        if (isAuth)
            return (
                <div>
                    <ReferralNavbar />
                    <BrowserRouter basename='/geer'>
                        <Switch>
                            <Route exact path='/reports' >
                                <DownloadCSV instance={this.state.instance} />
                            </Route>
                            <Route exact path='/' >
                                <ReferralForm instance={this.state.instance} />
                            </Route>
                        </Switch>
                    </BrowserRouter>
                </div>
            )
        else return (<div></div>)
    }
}

export default App = withMsal(App);
